var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"switch",class:_vm.classNames,on:{"click":_vm.click}},[(_vm.hasSlot)?_c('div',{staticClass:"switch__label"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }